import { render, staticRenderFns } from "./NotificationActivitySearch.vue?vue&type=template&id=24d3ca88&scoped=true"
import script from "./NotificationActivitySearch.vue?vue&type=script&lang=js"
export * from "./NotificationActivitySearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d3ca88",
  null
  
)

export default component.exports